var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.058 13.761c3.898 0 7.058-1.275 7.058-2.847s-3.16-2.847-7.058-2.847C6.16 8.067 3 9.342 3 10.914s3.16 2.847 7.058 2.847ZM17.116 13.761c0 1.579-3.16 2.847-7.058 2.847C6.161 16.608 3 15.34 3 13.761M17.116 16.617c0 1.579-3.16 2.847-7.058 2.847C6.161 19.464 3 18.186 3 16.617M17.116 10.914v5.704M3 10.914v5.704",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.985 6.848v3.06-.213c0 1.578 3.161 2.847 7.058 2.847 3.898 0 7.059-1.279 7.059-2.847v.213-3.06H6.985Z",
    fill: "#F5F5F5",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.034 9.694c3.898 0 7.058-1.274 7.058-2.847 0-1.572-3.16-2.847-7.058-2.847-3.898 0-7.058 1.275-7.058 2.847 0 1.573 3.16 2.847 7.058 2.847Z",
    fill: "#F5F5F5",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.f74683d9.svg";
export { ForwardRef as ReactComponent };